import { Shadow, Text, Icon, HStack } from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { ResponsesBrokerageInvoiceItemResponse } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';
import { RouteProp, useRoute } from '@react-navigation/native';
import { Pressable } from 'native-base';
import React from 'react';

import { CustomerDetailStackParamList } from '../../../../../../../../routes/types';
import { useReportsActions } from '../../../../../../../../store/customerDetail/reports/actions';
import { validateAndFormatValue } from '../../../Statements/Table/constants';

interface ItemProps {
  item: ResponsesBrokerageInvoiceItemResponse;
}

export const Item: React.FC<ItemProps> = ({ item }) => {
  const { params } = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();

  const accountNumber = params?.accountNumber;

  const { handleDownloadBrokerageInvoiceFile } = useReportsActions();

  const getBrokerageItemFile = () => {
    if (item?.link && item?.link?.length > 0) {
      window.open(item?.link, '_blank');
    } else {
      const invoiceDate = Utils.Mask.DateFormat(item.brokerageInvoiceDate!, 'yyyy-MM-dd');
      const fileName = `${item.invoiceType || ''} ${invoiceDate}.pdf`;
      handleDownloadBrokerageInvoiceFile({
        accountNumber,
        fileName,
        invoiceDate: invoiceDate as unknown as Date,
      });
    }
  };

  return (
    <Shadow
      borderRadius={BoxBorder.heavy}
      level={3}
      mx={{ base: Spacing['inline.xxxs'], md: Spacing['inline.xxxs'] }}>
      <HStack
        px={Spacing['inline.xxxs']}
        py={Spacing['inline.xxs']}
        alignItems="center"
        justifyContent="space-between"
        borderRadius={BoxBorder.heavy}>
        <HStack alignItems="center" space={Spacing['inline.xxxs']}>
          <Pressable onPress={getBrokerageItemFile}>
            <Icon name="Pdf" size="xs" color={Color['brand.tertiary.principal']} />
          </Pressable>
          <Text color={'neutral.dark'} variant="semibold" fontSize={Typography['fontsize.md']}>
            {item.invoiceType}
          </Text>
          <Text color={'neutral.dark'} variant="semibold" fontSize={Typography['fontsize.md']}>
            {validateAndFormatValue(item?.brokerageInvoiceDate as Date, 'date')}
          </Text>
        </HStack>
        <Pressable onPress={getBrokerageItemFile}>
          <Icon name="Download" size="xs" color={Color['brand.tertiary.principal']} />
        </Pressable>
      </HStack>
    </Shadow>
  );
};
